<script lang="ts">
    import { apiBaseOverride } from "../../store"
    import Counter from "../Counter.svelte"
    import InView from "../InView.svelte"
    import LinkList from "../LinkList.svelte"
    import MedialibImage from "../MedialibImage.svelte"

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase

    export let card: BlockContentCard
    export let hasNumberCard: boolean = false
    /* ist hasnumbercard einfach immer false? */
    /* export let border: "line" | "space" = "space"  */
    export let border: "line" | "card" | "space" = "space"
</script>

<!-- is admin view or not hidden -->
{#if apiBase || !card.hide}
    <article
        class:hidden="{!!card.hide}"
        class="{border == 'space'
            ? 'col-md-4 col-12 col-grid gap-m'
            : 'col-lg-auto col-md-4 col-sm-6 col-12 vp-xl hp-xl col-grid gap-m'}"
        class:number-card="{hasNumberCard || border == 'space' || border == 'card'}"
        class:col-lg-auto="{!card.colWidth}"
        class:col-md-3="{card.colWidth}"
        class:grid-height="{(border == 'line' || border == 'space' || !border) &&
            card.image &&
            !card.counter?.value &&
            card.title}"
        class:grid-bleed="{border == 'line' || border == 'space' || !border}"
    >
        {#if card.title || card.iconClass || card.icon || card.counter?.value}
            <header class="{hasNumberCard ? 'border-bottom' : 'col-grid gap-m'} ">
                {#if card.iconClass || card.icon}
                    <div class="icon">
                        {#if card.iconClass}
                            <span class="si-{card.iconClass}"></span>
                        {:else}
                            <figure>
                                <MedialibImage id="{card.icon}" />
                            </figure>
                        {/if}
                    </div>
                    <!-- Icon optional -->
                    <div class="headline">
                        <h3>{card.title}</h3>
                    </div>
                {:else if card.counter?.value}
                    <div class="number">
                        <span class="counting">
                            <InView options="{{ unobserveOnEnter: true, rootMargin: '-50px' }}">
                                <Counter value="{card.counter.value}" />
                                <fragment slot="not-in-view">0</fragment>
                            </InView>
                        </span>

                        {card.counter?.unit}
                    </div>
                    <div class="headline">
                        <h3 class="text">{card.title}</h3>
                    </div>
                {:else}
                    <div class="headline">
                        <h3>{card.title}</h3>
                    </div>
                {/if}
            </header>
        {/if}
        {#if card.image}
            <div class="background-image">
                <!-- Bild optional -->
                <figure>
                    <MedialibImage id="{card.image}" />
                </figure>
            </div>
        {/if}
        {#if card.text}
            <div class="text" class:col-auto="{!hasNumberCard}">
                {@html card.text}
            </div>
        {/if}
        {#if card.links?.length}
            <nav class="vertical" class:col-12="{!hasNumberCard}">
                <!-- Mini Menü innerhalb des Blocks, beliebig viele Links möglich -->
                <LinkList links="{card.links}" />
            </nav>
        {/if}
    </article>
{/if}

<style lang="less">
    .hidden {
        opacity: 0.5 !important;
        filter: grayscale(100%);
    }
</style>
